import classNames from 'classnames';

const Radio = ({
  selected,
  theme = 'light',
}: {
  selected: boolean;
  theme?: 'light' | 'dark';
}) => (
  <div
    className={classNames(
      'relative flex h-4 w-4 shrink-0 items-center justify-center rounded-full border border-gray-700 transition-all duration-150 ease-in-out',
      {
        'opacity-30': !selected && theme === 'light',
      },
    )}
  >
    <div
      className={classNames(
        `h-2.5 w-2.5 rounded-full transition duration-150 ease-in-out`,
        {
          'bg-gray-700': selected,
          'bg-transparent group-hover:bg-gray-700': !selected,
        },
      )}
    />
  </div>
);

export default Radio;
